import axios from '@/utils/axios'

export const getStorageTankList = (payload) => {
    return axios.get('/storageTank', {
        params: payload
    })
}

export const getStorageTankByID = (id) => {
    return axios.get(`/storageTank/${id}`)
}

export const updateStorageTank = (id, data) => {
    return axios.put(`/storageTank/${id}`, data)
}

export const createStorageTank = (data) => {
    return axios.post(`/storageTank`, data)
}

export const deleteStorageTank = (id) => {
    return axios.delete(`/storageTank/${id}`)
}